import React from 'react'
import { CustomModal } from '../CustomModal/CustomModal'
import { t } from 'i18next'

export const AlertModal = ({ showModal, icon, message, onClose }) => {
    return (
        <CustomModal
            showModal={showModal}
            setShowModal={onClose}
            centered
        >
            <div className='d-flex flex-column align-items-center justify-content-center'>
                <img
                    src={icon}
                    alt="alert-icon"
                />
                <p className='mt-3 text-center param-section-title'>
                    {message}
                </p>
                <p
                    type="button"
                    className='custom-modal-btn-ok'
                    onClick={onClose}
                >
                    {t('UNDERSTOOD')}
                </p>
            </div>
        </CustomModal>

    )
}
